import { Menu } from 'antd';
import { Icon } from 'components';
import React, { useContext, useEffect, useState } from 'react';
import {
  AiOutlineCustomerService,
  AiOutlineDesktop,
  AiOutlineDownload,
  AiOutlineFileText,
  AiOutlineNotification,
  AiOutlineQuestionCircle,
  AiOutlineSnippets,
} from 'react-icons/ai';
import { NavLink, useLocation } from 'react-router-dom';
import MenuContext from 'store/MenuContext';

// FIXME: 메뉴 구조인데 라우터랑 묶어 별도 관리 필요
const menus = [
  {
    key: 'desktops',
    name: 'Desktops',
    to: '/desktops',
    icon: <Icon name={<AiOutlineDesktop />} />,
  },
  {
    key: 'transfer',
    name: '파일 다운로드',
    to: '/transfer',
    icon: <Icon name={<AiOutlineFileText />} />,
  },
  {
    key: 'request',
    name: '서비스 신청',
    to: '/request',
    icon: <Icon name={<AiOutlineSnippets />} />,
  },
  {
    key: 'help',
    name: 'Help Center',
    icon: <Icon name={<AiOutlineCustomerService />} />,
    children: [
      {
        key: 'notice',
        name: '공지사항',
        to: '/help/notice/list',
        icon: <Icon name={<AiOutlineNotification />} />,
      },
      {
        key: 'faq',
        name: 'FAQ',
        to: '/help/faq',
        icon: <Icon name={<AiOutlineQuestionCircle />} />,
      },
      {
        key: 'download',
        name: '다운로드',
        to: '/help/download',
        icon: <Icon name={<AiOutlineDownload />} />,
      },
    ],
  },
];

function AppNavigation() {
  const [selectedKeys, setSelectedKeys] = useState([]); // 현재 선택된 메뉴
  const [openKeys, setOpenKeys] = useState([]);

  const hideMenus = useContext(MenuContext); // 숨길 메뉴

  // 메뉴 숨김 처리
  const filteredhideMenus = menus.filter((menu) => !hideMenus.includes(menu.key));

  // FIXME: 현재 페이지를 네비게이션에 표시하기 위한 임시 조치
  const currentUrl = useLocation().pathname;
  const currentUrlSplit = currentUrl.split('/');
  let currentPage;
  if (currentUrlSplit.includes('help')) {
    /* eslint-disable prefer-destructuring */
    currentPage = currentUrlSplit[2];
  } else {
    currentPage = currentUrlSplit[1];
  }
  useEffect(() => {
    setSelectedKeys(currentPage);
    if (currentUrlSplit.includes('help')) {
      setOpenKeys(['help']);
    }
  }, [useLocation().pathname]);

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  return (
    <>
      <Menu
        defaultSelectedKeys="desktops"
        selectedKeys={selectedKeys}
        mode="inline"
        style={{
          backgroundColor: 'transparent',
          borderRightColor: 'transparent',
        }}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      >
        {filteredhideMenus.map((menu) => {
          let MenuItem;
          if (menu.children) {
            MenuItem = (
              <Menu.SubMenu key={menu.key} icon={menu.icon} title={menu.name}>
                {menu.children.map((childrenMenu) => (
                  <Menu.Item
                    key={childrenMenu.key}
                    icon={childrenMenu.icon}
                    style={{ display: childrenMenu.isHide && 'none' }}
                  >
                    <NavLink to={childrenMenu.to}>{childrenMenu.name}</NavLink>
                  </Menu.Item>
                ))}
              </Menu.SubMenu>
            );
          } else {
            MenuItem = (
              <Menu.Item key={menu.key} icon={menu.icon} style={{ display: menu.isHide && 'none' }}>
                <NavLink to={menu.to}>{menu.name}</NavLink>
              </Menu.Item>
            );
          }
          return MenuItem;
        })}
      </Menu>
    </>
  );
}

export default AppNavigation;
